import { useQuery } from '@tanstack/react-query';
import * as publicConfigService from '@/services/publicConfigService';

/**
 * Hook to fetch a single public config value (no auth required).
 */
export function usePublicConfig(configKey: string) {
  return useQuery({
    queryKey: ['publicConfig', configKey],
    queryFn: () => publicConfigService.getPublicConfig(configKey),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  });
}

/**
 * Hook to fetch all public configs.
 */
export function usePublicConfigs() {
  return useQuery({
    queryKey: ['publicConfigs'],
    queryFn: () => publicConfigService.getPublicConfigs(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
